<template>
  <div
    @click="handleHide"
    v-if="visible"
    class="fixed bottom-5 right-5 left-5 md:left-1/2 md:-translate-x-1/2 md:bottom-auto md:right-auto md:top-6 p-5 md:px-4 md:py-3 text-lg md:text-base rounded shadow-lg z-50"
    :class="[
      config.type === 'success' ? 'bg-brand-primary-800' : null,
      config.type === 'error' ? 'bg-red-800 text-white' : null,
      config.type === 'warning' ? 'bg-yellow-500 text-black' : null,
      config.type === 'info' ? 'bg-brand-primary-800 text-white' : null,
    ]"
  >
    <p class="text-sm font-bold">{{ config.message }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      config: {
        message: '',
        type: 'info',
      },
      timeoutId: null,
    };
  },
  created() {
    // Listen for 'snackbar' events
    window.app.on('snackbar', this.handleSnackbar);
  },
  unmounted() {
    // Cleanup event listeners
    window.app.off('snackbar', this.handleSnackbar);
  },
  methods: {
    handleHide() {
      this.visible = false;
    },
    handleSnackbar(config = {}) {

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.config = { ...this.config, ...config };
      this.visible = true;

      const duration = config.duration || 5000;
      this.timeoutId = setTimeout(() => {
        this.visible = false;
      }, duration);
    },
  },
};
</script>

<style scoped>
/* No additional CSS needed, Tailwind handles all styles */
</style>
